import { createAction } from '@reduxjs/toolkit';
import * as types from './types';

export default {
  resetLoading: (payload) => ({ type: types.RESET_LOADING, payload }),
  setLoading: (payload) => ({ type: types.SET_LOADING, payload }),
  setPageLoading: createAction(types.SPACE_PROCESSING),
};
